import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Truck } from "lucide-react";

export function ProtectedRoute({ children, role }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background">
        <Truck className="h-10 w-10 text-kinetic animate-pulse" />
        <p className="font-mono text-sm text-muted-foreground uppercase tracking-widest">Loading MoveTender…</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/auth" replace />;
  if (role && user.role !== role) return <Navigate to="/dashboard" replace />;
  return children;
}
